import React from "react";
import "../styles.css";

type CoachMarkStepTwoProps = {
  visible: boolean;
  houseName?: string;
  onNext: () => void;
};

const CoachMarkStepTwo = ({
  visible,
  houseName = "Amethyst",
  onNext,
}: CoachMarkStepTwoProps) => {
  if (!visible) return null;

  return (
    <div
      className="coachmark-overlay"
      role="dialog"
      aria-modal="true"
      aria-label="Coach mark step two"
    >
      <div className="coachmark-step-two-card">
        <div className="coachmark-step-two-inner">
          <div className="coachmark-step-two-bubble mt-3">
            <div className="coachmark-step-two-text">Congrats! You've</div>
            <div className="coachmark-step-two-text">been placed in</div>
            {/* <div className="coachmark-step-two-house">the {houseName}</div> */}
            <div className="coachmark-step-two-house">a</div>
            <div className="coachmark-step-two-house">House!</div>
          </div>

          <img
            src={require("../../assets/Item2.png")}
            alt="U mascot"
            className="coachmark-step-two-mascot"
          />

          <button
            type="button"
            onClick={onNext}
            className="coachmark-step-two-next"
            aria-label="Next coach mark"
          >
            <img
              src={require("../../assets/pink-left-arrow.png")}
              alt=""
              aria-hidden="true"
              className=""
            />
          </button>
        </div>
      </div>
    </div>
  );
};

export default CoachMarkStepTwo;
